/**
 * The published support address, safe to import from client components.
 *
 * Split out of `lib/privacy/inventory.ts` because that module is imported by
 * server code that reads `process.env`, and a client bundle should not pull a
 * server module in just to render a `mailto:`. Same value, one place to change
 * it: `GRIEVANCE` re-exports from here.
 */
export const GRIEVANCE_EMAIL =
  process.env.NEXT_PUBLIC_SUPPORT_EMAIL ?? "privacy@deepsoch.ai";
